export const VEHICLE_EQUIPMENT_SLOTS = [
  { field: 'defaultWheelId', type: 'wheel', label: 'Ruedas', selectId: 'calibrator-default-wheel' },
  { field: 'defaultEngineSoundId', type: 'engine_sound', label: 'Sonido de motor', selectId: 'calibrator-default-engine-sound' },
  { field: 'defaultCannonId', type: 'cannon', label: 'Cañón', selectId: 'calibrator-default-cannon' },
  { field: 'defaultProjectileId', type: 'projectile', label: 'Proyectil', selectId: 'calibrator-default-projectile' },
  { field: 'defaultNitroId', type: 'nitro', label: 'Nitro', selectId: 'calibrator-default-nitro' },
  { field: 'defaultExplosionId', type: 'explosion', label: 'Explosión', selectId: 'calibrator-default-explosion' },
  { field: 'defaultTombstoneId', type: 'tombstone', label: 'Lápida', selectId: 'calibrator-default-tombstone' },
];

export function publishedEquipmentOptions(items = [], type) {
  return items.filter((item) => item.type === type && item.status === 'published');
}

// Called only for a NEW vehicle. Existing profiles must keep their chosen IDs.
export function initialVehicleEquipment(items, current = {}) {
  const game = { ...current };
  for (const { field, type } of VEHICLE_EQUIPMENT_SLOTS) {
    const options = publishedEquipmentOptions(items, type);
    if (options.some((item) => item.id === game[field])) continue;
    const cannon = items.find((item) => item.type === 'cannon' && item.status === 'published' && item.id === game.defaultCannonId);
    const cannonProjectile = field === 'defaultProjectileId'
      ? options.find((item) => item.id === cannon?.profile?.design?.defaultProjectileId)
      : null;
    if (options.length) game[field] = (cannonProjectile || options[0]).id;
  }
  return game;
}
